import { ofType } from 'redux-observable';
import { map, switchMap } from 'rxjs/operators';

import * as actions from '@redux/actions/productReview';
import * as productReviewTypes from '@redux/actions/productReview/productReviewTypes';
import { getAsObservable } from '@services/genericService';
import { deepCopy } from '@utils/utility';

import * as config from './config';

export const getProductsReviewEpic = (action$) =>
  action$.pipe(
    ofType(productReviewTypes.GET_PRODUCT_REVIEW),
    switchMap((action) => {
      const params = {
        productId: action.payload.productId,
        page: action.payload.page,
        pageSize: action.payload.pageSize
      };

      return getAsObservable(config.ACTION_GET_PRODUCT_REVIEW, params).pipe(
        map((res) => {
          if (res.status === 200) {
            return actions.getProductReviewSuccess(deepCopy(res.data));
          } else {
            return actions.getProductReviewFailed('Failed');
          }
        })
      );
    })
  );
